import { FactOperator } from './fact-operator';

export class DivisionOperator implements FactOperator {
	public calculate(values: number[]): number {
		const firstValue = values.shift();
		return firstValue / values.reduce((val1, val2) => val1 * val2, 1);
	}
}
